export class GetCUPCurPlanCopyToInput{
    Years: string = ''
    DeptNo: string = ''
    TeamNo: string = ''
    TargetYears: string = ''
    TargetDeptNo: string = ''
    TargetTeamNo: string = ''
}